// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"06266b73","317":"6fa34748"}[chunkId] + ".chunk.js";
};